import React from 'react';
import { Tooltip as ReactTooltip } from 'react-tooltip';

type Props = {
  children: React.ReactNode;
  value: string | string[];
  hidden?: boolean;
};

const Tooltip = ({ children, value, hidden = false }: Props) => {
  if (hidden) {
    return children;
  }

  const id = `tooltip-id-${Math.random().toFixed(12).slice(2)}`;
  const displayValue = Array.isArray(value) ? value.join(', ') : value;

  return (
    <>
      <div data-tooltip-id={id} data-tooltip-content={displayValue}>
        {children}
      </div>
      <ReactTooltip id={id} />
    </>
  );
};

export default Tooltip;
